import { Control, Controller, UseFormTrigger, UseFormWatch } from 'react-hook-form';
import { RadioGroup } from 'src/components/ui/radio-group';
import { WorkflowEscalatedListItem } from './WorkflowEscalatedListItem';
import { clsx } from 'clsx';
import type {
  WorkflowActionPath,
  WorkflowFormValues,
} from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';

export const WorkflowEscalatedList = ({
  namePrefix = 'action.0',
  control,
  watch,
  trigger = () => Promise.resolve(true),
  className = '',
  isCustom,
}: {
  namePrefix?: WorkflowActionPath;
  control: Control<WorkflowFormValues>;
  watch: UseFormWatch<WorkflowFormValues>;
  trigger?: UseFormTrigger<WorkflowFormValues>;
  className?: string;
  isCustom?: boolean;
}) => {
  const name = `${namePrefix}.action_escalated_list` as const;
  const listValue = watch(name);

  return (
    <div className={clsx('input-container', className)}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            onValueChange={onChange}
            defaultValue={value}
            className="flex flex-col gap-2.5"
          >
            <WorkflowEscalatedListItem
              control={control}
              watch={watch}
              namePrefix={namePrefix}
              isExpanded={listValue === 'handle_with_crm'}
              label={'Escalate immediately'}
              description={
                'AI logs a ticket in your helpdesk as soon as an escalation is required.'
              }
              value={'handle_with_crm'}
              isCustom={isCustom}
            />
            <WorkflowEscalatedListItem
              control={control}
              watch={watch}
              namePrefix={namePrefix}
              isExpanded={listValue === 'collect_and_escalate'}
              label={'Gather details and escalate'}
              description={
                'AI gathers contact or other details and then logs a ticket in your helpdesk.'
              }
              value={'collect_and_escalate'}
              trigger={trigger}
              isCustom={isCustom}
            />
            <WorkflowEscalatedListItem
              control={control}
              watch={watch}
              namePrefix={namePrefix}
              isExpanded={listValue === 'forward_to_email'}
              label={'Forward to email'}
              description={'Send the full transcript or summary to an email address.'}
              value={'forward_to_email'}
              trigger={trigger}
              isCustom={isCustom}
            />
            <WorkflowEscalatedListItem
              control={control}
              watch={watch}
              namePrefix={namePrefix}
              isExpanded={listValue === 'close'}
              label={'End conversation'}
              description={'Close the conversation with a custom message.'}
              value={'close'}
              isCustom={isCustom}
            />
          </RadioGroup>
        )}
      />
    </div>
  );
};
